import { groupBy } from 'utils';

class Animations {
  constructor(elements) {
    this.defaultOptions = {
      threshold: 0.6,
      rootMargin: '-30px 0px',
    };

    // Gets a set of grouped elements using the anim-thresholds (threshold for intersection observer)
    const groupedElements = groupBy(elements, element =>
      element.getAttribute('data-anim-threshold'),
    );

    groupedElements.forEach((value, key) => {
      const options = { ...this.defaultOptions };
      const threshold = parseFloat(key);

      if (!isNaN(threshold) && threshold < 1.0) {
        options.threshold = threshold;
      }

      this.createObserver(value, options);
    });
  }

  /**
   * Creates an IntersectionObserver for the given elements using the given options
   * @param {NodeList} elements
   * @param {Object} options
   */
  createObserver = (elements, options) => {
    const observer = new IntersectionObserver(entries => this.handleEntries(entries), options);
    Array.forEach(elements, element => observer.observe(element));
  };

  /* handle entries run when a new element is observed (comes into view) */
  handleEntries = entries => {
    Array.forEach(entries, event => {
      const cssClass = event.target.getAttribute('data-anim');
      const reverse = event.target.getAttribute('data-anim-reverse') !== null;

      if (!event.isIntersecting) {
        if (reverse) {
          event.target.classList.remove(cssClass);
        }

        return;
      }

      event.target.classList.add(cssClass);
    });
  };
}

$(document).ready(() => {
  const elements = document.querySelectorAll('[data-anim]');

  if (!elements.length) {
    return;
  }

  // eslint-disable-next-line
  new Animations(elements);
});
